import { useEffect, useRef, useState } from "react";

export default function AboutSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="w-full bg-white py-[120px]" ref={ref}>
      <div className="max-w-[1200px] mx-auto px-10">
        <div
          className={`grid grid-cols-2 gap-20 items-center transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          {/* Left — Text */}
          <div>
            <span className="text-[12px] uppercase tracking-[3px] text-emerald-600 font-semibold">
              About Us
            </span>
            <h2 className="text-[44px] font-bold text-[#0A0A0A] leading-[1.15] mt-4 mb-6">
              Building Modern
              <br />
              iOS Solutions
            </h2>
            <p className="text-[17px] text-[#555] leading-[1.8] mb-5">
              KESTEN d. o. o. is a dedicated team of iOS developers, designers, and security specialists committed to crafting applications that genuinely improve people&apos;s digital lives.
            </p>
            <p className="text-[17px] text-[#555] leading-[1.8] mb-5">
              Founded with a clear mission — to bring enterprise-grade security and performance tools to everyday iPhone users — we combine deep platform knowledge with a passion for clean, intuitive design.
            </p>
            <p className="text-[17px] text-[#555] leading-[1.8]">
              Every product we ship goes through rigorous testing to ensure reliability, privacy compliance, and a seamless user experience. Our apps are built natively for iOS, leveraging the full power of Apple's ecosystem.
            </p>

            {/* Pillars */}
            <div className="mt-10 flex flex-col gap-4">
              {[
                { icon: "ri-lock-line", title: "Privacy Focused", desc: "Zero logs, zero tracking, zero compromises." },
                { icon: "ri-code-s-slash-line", title: "Native iOS Craftsmanship", desc: "Built with Swift for peak performance." },
                { icon: "ri-customer-service-2-line", title: "Dedicated Support", desc: "Real humans ready to help anytime." },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-4 p-4 rounded-xl hover:bg-[#F8F9FA] transition-colors">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-emerald-50 text-emerald-600 flex-shrink-0">
                    <i className={`${item.icon} text-xl`} />
                  </div>
                  <div>
                    <p className="text-[15px] font-semibold text-[#0A0A0A]">{item.title}</p>
                    <p className="text-[14px] text-[#777] mt-0.5">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Image only */}
          <div className="flex flex-col">
            <div className="w-full h-[420px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/1232c3a12c6ba7e424ed3cffbc7c6cec.jpg"
                alt="KESTEN development team workspace"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
